var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//region import

// models
import model from '../base.model';
import { loginModel } from '../auth/login.model';

// constants
import urls from '../../constants/urls.constant';
import { config } from '../../config/apiConfig';

// storage
import { getServerUrl as settingsGetServerUrl } from '../../device/settings.storage';

// utils
import { dateToTst, dateToMomentDate, roundNumber } from '../../utils/helpers';
import { convertServerDataToModelData, calcEnergySum, calcEnergyItems, compareCostItems } from '../../services/core/cost/cost.helper';

//endregion


class costModel extends model {

    constructor(props) {
        super(props);
    }
    //region init

    static create() {
        return _extends({}, super.create(), {
            chart: {
                isLoading: false,
                min: {
                    x: 0,
                    y: 0
                },
                max: {
                    x: 0,
                    y: 0
                },
                items: []
            },
            energy: {
                isLoading: false,
                energySum: {
                    P: 0
                },
                energyItems: [],
                otherEnergySum: 0
            }
        });
    }

    //endregion
    //region model

    static processServerResponse(dispatch, params, model, serverResponse, history) {}

    static isClientEmpty(clientModel) {
        return !clientModel;
    }

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }
        const reducers = {
            [model.TYPE_GET_ENERGY_SUM]: model.reduceGetEnergySum.bind(model),
            [model.TYPE_REQUEST_ENERGY_ENERGY_SUM]: model.reduceRequestEnergySum.bind(model),
            [model.TYPE_REQUEST_ENERGY_CHART_DATA]: model.reduceRequestEnergyChartData.bind(model)
        };

        return reducers[type];
    }

    //endregion
    //region api chart

    static apiGet(clientApiMethod, params = {}, dispatch, failAction) {
        var _this = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this.mapEnergyChartDataToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getEnergyChartData(urlParams);

            dispatch(_this.actionRequestEnergyChartData(_this, { modelClient: { isLoading: true }, model: _this }));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken).then(function (serverResponse) {
                const modelClient = _this.mapEnergyChartDataToClient(serverResponse, params);
                dispatch(_this.dispatchModel({ modelClient, model: _this }));
            }).catch(function (error) {
                _this.catchRequest(_this, dispatch, failAction)(error);
                dispatch(_this.actionRequestEnergyChartData(_this, { modelClient: { isLoading: false }, model: _this }));
            });
        })();
    }

    static actionRequestEnergyChartData(model, payload) {
        return {
            type: model.TYPE_REQUEST_ENERGY_CHART_DATA,
            payload
        };
    }

    static reduceRequestEnergyChartData(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                chart: _extends({}, stateModel.chart, {
                    isLoading: modelClient.isLoading
                })
            })
        };
    }

    static mapEnergyChartDataToClient(serverResponse, params) {
        const { chart } = this.create();
        let modelData = { chart };

        if (!serverResponse) {
            return modelData;
        }

        const serverModel = this.mapEnergyChartDataToServer(params);
        const { from, to, scale, type } = serverModel.urlParams;
        convertServerDataToModelData(modelData, from, to, scale, type, serverResponse.sum, serverModel.items.length);
        modelData.chart.isLoading = false;

        return modelData;
    }

    static mapEnergyChartDataToServer(clientModel) {
        if (super.isEmpty(clientModel) || !clientModel.type || !clientModel.to || !clientModel.from) {
            return {
                urlParams: {}
            };
        }

        const from = dateToTst(dateToMomentDate(clientModel.from));
        const to = dateToTst(dateToMomentDate(clientModel.to)) + 1;
        const scale = 50;
        let delta = (to - from) / (scale - 2);

        return {
            items: clientModel.items,
            urlParams: {
                to,
                from: from - delta,
                scale: scale,
                interpolate: 0,
                type: clientModel.type
            }
        };
    }

    static reduceGet(stateModel, action) {
        const { modelClient, model } = action.payload;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, modelClient)
        };
    }

    //endregion
    //region api energy sum

    static apiGetEnergySum(clientApiMethod, params = {}, dispatch, failAction) {
        var _this2 = this;

        return _asyncToGenerator(function* () {
            const serverModel = _this2.mapEnergySumToServer(params);
            const { urlParams } = serverModel;
            const authData = yield loginModel.storageGetAuthToken(loginModel);
            const { authToken } = authData;
            const serverUrl = yield settingsGetServerUrl();
            const url = urls.core.getEnergyConsumption(urlParams);

            dispatch(_this2.actionRequestEnergySum(_this2, { modelClient: { isLoading: true }, model: _this2 }));

            return clientApiMethod(serverUrl, url, serverModel.payload, authToken).then(function (controlsStatus) {
                const modelClient = _this2.mapEnergySumToClient(controlsStatus, params);
                dispatch(_this2.actionGetEnergySum(_this2, { modelClient, model: _this2 }));
            }).catch(function (error) {
                _this2.catchRequest(_this2, dispatch, failAction)(error);
                dispatch(_this2.actionRequestEnergySum(_this2, { modelClient: { isLoading: false }, model: _this2 }));
            });
        })();
    }

    static actionRequestEnergySum(model, payload) {
        return {
            type: model.TYPE_REQUEST_ENERGY_ENERGY_SUM,
            payload
        };
    }

    static reduceRequestEnergySum(stateModel, action, state) {
        const { modelClient, model } = action.payload;
        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                energy: _extends({}, stateModel.energy, {
                    isLoading: modelClient.isLoading
                })
            })
        };
    }

    static mapEnergySumToClient(serverResponse, params) {
        if (!serverResponse || !serverResponse.sum) {
            return {
                energySum: this.create().energySum
            };
        }
        const serverModel = this.mapEnergySumToServer(params);
        const { from, to, scale } = serverModel.urlParams;
        const P = calcEnergySum(serverModel.costMode, serverResponse.sum);
        const energyItems = calcEnergyItems(from, to, scale, serverModel.costMode, serverResponse);
        energyItems.sort(compareCostItems);

        const otherEnergySum = energyItems.map((item, index) => item.power > 0 && index >= 3 ? +item.power : 0).reduce((a, b) => a + (b > 0 ? b : 0), 0);

        return {
            energy: {
                isLoading: false,
                energySum: {
                    P
                },
                energyItems,
                otherEnergySum: roundNumber(otherEnergySum, 4)
            }
        };
    }

    static mapEnergySumToServer(clientModel) {
        if (super.isEmpty(clientModel)) {
            return {
                urlParams: {}
            };
        }

        const from = dateToTst(dateToMomentDate(clientModel.from));
        const to = dateToTst(dateToMomentDate(clientModel.to));

        return {
            urlParams: {
                scale: 2,
                from,
                to
            },
            costMode: clientModel.costMode
        };
    }

    static actionGetEnergySum(model, payload) {
        return dispatch => {
            dispatch({
                type: model.TYPE_GET_ENERGY_SUM,
                payload
            });
        };
    }

    static reduceGetEnergySum(stateModel, action) {
        const { modelClient, model } = action.payload;
        const {
            energy
        } = modelClient;

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                energy
            })
        };
    }
}

costModel.MODEL_NAME = 'costModel';
costModel.TYPE_REQUEST = 'REQUEST_COST';
costModel.TYPE_FROM_SERVER = 'GET_COST';
costModel.TYPE_CLEAR = 'CLEAR_COST';
costModel.TYPE_REQUEST_ENERGY_CHART_DATA = 'TYPE_REQUEST_ENERGY_CHART_DATA';
costModel.TYPE_GET_ENERGY_SUM = 'TYPE_GET_ENERGY_SUM';
costModel.TYPE_REQUEST_ENERGY_ENERGY_SUM = 'TYPE_REQUEST_ENERGY_ENERGY_SUM';
export { costModel };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/core/cost.model.js